module.exports = __webpack_public_path__ + "img/what8.4c73b974.png";